import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractAccountRowTemplate from "./AbstractAccountRowTemplate.js";
import AccountRow from "../../reports/rows/AccountRow.js";

/**
 * Row representing a single account.
 *
 * @param {number} spec.accountNumber - Account number associated to this row
 */
export default class AccountRowTemplate extends AbstractAccountRowTemplate {
	constructor({ accountNumber } = {}) {
		super(...arguments);

		this._accountNumber = accountNumber;
	}

	getAccountNumber() {
		return this._accountNumber;
	}

	setAccountNumber(accountNumber) {
		this._accountNumber = accountNumber;
	}

	getTitle() {
		return this.getAccountNumber();
	}

	accept(visitor) {
		return visitor.visitAccountRowTemplate(this);
	}

	_instanceClass() {
		return AccountRow;
	}

	_interpretationSpec(interpreter) {
		const spec = super._interpretationSpec(...arguments);
		const context = interpreter.getContext();
		const account = context.findAccount(this._accountNumber);

		spec.account = account;

		return spec;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.accountNumber = this.getAccountNumber();

		return properties;
	}

	static getLabel() {
		return _("Account row");
	}

	static getType() {
		return "AccountRowTemplate";
	}
}
